module.exports = __webpack_public_path__ + "img/blaupunkt.1a6c5e9.png";